import React from 'react';
import ComplaintsBoard from './ComplaintBoard';

const AllComplaints = () => (
    <ComplaintsBoard
        statusFilter="All"
        title="Complaints Management"
        subtitle="Monitor and resolve user complaints"
    />
);

export default AllComplaints;